import React from "react";
import { Link } from "react-router-dom";
import "./Tile.css";

function Tile({ imageSrc, text, buttonText, link }) {
  return (
    <div className="tile-wrapper">
      {/* 1. Image Tile (Zooming effect applied via CSS) */}
      <div
        className="tile-box custom-image"
        style={{ backgroundImage: `url(${imageSrc})` }}
      >
        <div className="tile-overlay">
          <p className="tile-text">{text}</p>
        </div>
      </div>

      {/* 2. Bouncing Arrow Indicator (Styled via CSS) */}
      <div
        className="bounce-indicator"
        role="presentation"
        aria-hidden="true"
      ></div>

      {/* 3. Button Link */}
      <Link to={link} className="tile-button-link">
        <button className="tile-button">{buttonText}</button>
      </Link>
    </div>
  );
}

export default Tile;
